/**
 * @file action
 */

import request from '@/common/request';
//common
export async function tradeTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/sys/V1.0/trade',
        params: params
    });
}

// 1.菜单
export async function menuListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/user/V1.0/getMenu',
        params: params
    });
}

// 首页-折线图
export async function registryListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/user/V1.0/registry/detail',
        params: params
    });
}
// 首页-折线图
export async function registryCountUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/user/V1.0/registry/data',
        params: params
    });
}


export async function policyListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/policy/V1.0/auth/list',
        params: params
    });
}
export async function policyInfoTypeListUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/policy/V1.0/infoType/list',
        params: params
    });
}
// 政策详情
export async function policyDetailUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/policy/V1.0/text/detail',
        params: params
    });
}
// 政策删除
export async function policyDelUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/policy/V1.0/text/del',
        params: params
    });
}
// 政策修改
export async function policyUpdateUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/policy/V1.0/text/auth',
        params: params
    });
}





// 乡村项目审核列表
export async function authListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/resource/V1.0/auth/list',
        params: params
    });
}
// 乡村项目类型
export async function infoTypeListUrl(params) {
    return await request({
        method: "get",
        url: "/admin/api/resource/V1.0/infoType/list",
        params: params
    });
}
// 信息类型
export async function projectTypeListUrl(params) {
    return await request({
        method: "get",
        url: "/admin/api/resource/V1.0/projectType/list",
        params: params
    });
}
// 审核状态
export async function stateListUrl(params) {
    return await request({
        method: "get",
        url: "/admin/api/sys/V1.0/authType/list",
        params: params
    });
}

// 文章详情
export async function textDetailUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/resource/V1.0/text/detail',
        params: params
    });
}

// 项目修改
export async function authModifyUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/resource/V1.0/text/auth',
        params: params
    });
}
// 项目删除
export async function textDelUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/resource/V1.0/text/del',
        params: params
    });
}





// 采购项目
export async function resourceListUrl(params) {
    return await request({
        method: "post",
        url: "/admin/api/resource/V1.0/purchase/auth/list",
        params: params
    });
}
// 信息类型
export async function purInfoTypeListUrl(params) {
    return await request({
        method: "get",
        url: "/admin/api/resource/V1.0/purchase/infoType/list",
        params: params
    });
}
// 项目修改
export async function resourceModifyUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/resource/V1.0/purchase/text/auth',
        params: params
    });
}
// 项目删除
export async function textResourceDelUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/resource/V1.0/purchase/text/del',
        params: params
    });
}
// 文章详情
export async function textPurDetailUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/resource/V1.0/purchase/text/detail',
        params: params
    });
}


//发布招标
export async function bidListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/release/V1.0/bid/list',
        params: params
    });
}
export async function releaseBidUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/release/V1.0/bid/getReleaseBid',
        params: params
    });
}
export async function updateBidStatusUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/release/V1.0/bid/updateStatus',
        params: params
    });
}


// 保函
export async function letterListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/letter/V1.0/list',
        params: params
    });
}

export async function updateLetterUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/letter/V1.0/update',
        params: params
    });
}
export async function letterTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/letter/V1.0/infoType/list',
        params: params
    });
}


export async function purchaseApplyUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/datamall/V1.0/queryPurchaseApply',
        params: params
    });
}
export async function mallDeleteUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/datamall/V1.0/delete',
        params: params
    });
}

export async function mallListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/datamall/V1.0/selectList',
        params: params
    });
}
export async function mallEditUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/datamall/V1.0/edit',
        params: params
    });
}
export async function mallAddUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/datamall/V1.0/add',
        params: params
    });
}

export async function authTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/sys/V1.0/release/authType/list',
        params: params
    });
}
export async function vipTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/user/V1.0/vipType',
        params: params
    });
}












// 轮播图列表
export async function carouseListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/carousel/V1.0/list',
        params: params
    });
}
// 轮播图新增
export async function carouseAddUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/carousel/V1.0/add',
        params: params
    });
}
// 轮播图修改
export async function carouseUpdateUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/carousel/V1.0/update',
        params: params
    });
}
// 轮播图删除
export async function carouseDelUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/carousel/V1.0/del',
        params: params
    });
}
// 轮播图状态
export async function photoStatusUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/carousel/V1.0/photoStatus',
        params: params
    });
}
// 启用禁用状态
export async function updateStatusUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/carousel/V1.0/updateStatus',
        params: params
    });
}
// 轮播图状态
export async function carouseTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/carousel/V1.0/typeList',
        params: params
    });
}


// 城市选择
export async function cityListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/sys/V1.0/region',
        params: params
    });
}
export async function userListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/user/V1.0/list',
        params: params
    });
}
export async function updateUserUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/user/V1.0/info/update',
        params: params
    });
}

export async function followTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/letter/V1.0/followType/list',
        params: params
    });
}

export async function purchaseFollowTypeUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/datamall/V1.0/changePurchaseFollowType',
        params: params
    });
}

export async function financeListUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/finance/V1.0/list',
        params: params
    });
}

export async function cycleTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/finance/cycle/V1.0/type/list',
        params: params
    });
}
export async function moneyTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/finance/money/V1.0/type/list',
        params: params
    });
}
export async function financeTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/finance/V1.0/type/list',
        params: params
    });
}
export async function orderStateTypeUrl(params) {
    return await request({
        method: 'get',
        url: '/admin/api/finance/V1.0/followType/list',
        params: params
    });
}
export async function orderFollowUpdateUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/finance/V1.0/update',
        params: params
    });
}


